module.exports = __webpack_public_path__ + "img/emerald-hill-logo-modal.fee5b80a.svg";